import Grid from "@mui/material/Grid2";
import { isEmpty } from "lodash";
import { Box, Divider } from "@mui/material";

import { TabSessionStorageResponse } from "../../../../models/api/TabSessionStorage";
import { flexRow } from "../../../../styles/mui/styles/display";
import { FieldSpacing } from "../../styles/style";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue, isNil } from "../../../../utils";
import { formatDate } from "../../../../utils/DateTime";
import { DateFormats } from "../../../../constants/Date";
import { Title } from "../../styles/OrderingPhysician";
import colors from "../../../../styles/colors/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import { TypographyBox } from "../../../../app/common/TextLabel";

export interface PropsFromState {
  tabSessionStorage: TabSessionStorageResponse;
}

type AllProps = PropsFromState;

const ReferralSource: React.FC<AllProps> = ({ tabSessionStorage }) => {
  const IsDischarged = getValue(tabSessionStorage, "response.referralSource.IsDischarged");
  const dischargeDate = getValue(tabSessionStorage, "response.referralSource.dischargeDate");
  let dateLabel = "Referral Date:";
  if (!isNil(IsDischarged)) {
    dateLabel = IsDischarged ? "Date of Discharge:" : "Expected Date of Discharge:";
  }

  return (
    <Box>
      <Grid container sx={flexRow}>
        {[
          {
            label: "Facility Name:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.facilityName"
            ),
          },
          {
            label: "NPI:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.referralSourceNpi"
            ),
          },
          {
            label : "Requestor Contact Name:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.referralSourceName"
            )
          },
          {
            label: "Phone:",
            value: `${getValue(
              tabSessionStorage,
              "response.referralSource.referralSourcePhoneNo"
            )} ${
              !isEmpty(
                getValue(
                  tabSessionStorage,
                  "response.referralSource.referralSourceExtension"
                )
              )
                ? "Ext: " +
                  getValue(
                    tabSessionStorage,
                    "response.referralSource.referralSourceExtension"
                  )
                : ""
            }`,
          },
          {
            label: "Fax:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.referralSourceFax"
            ),
          },
          {
            label : "Email:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.referralSourceEmail"
            )
          },
          {
            label: "Street 1:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.streetName1"
            ),
          },
          {
            label: "Street 2:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.streetName2"
            ),
          },
          {
            label: "City:",
            value: getValue(tabSessionStorage, "response.referralSource.city"),
          },
          {
            label: "State:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.referralSourceState"
            ),
          },
          {
            label: "County:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.county"
            ),
          },
          {
            label: "Zipcode:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.zipCode"
            ),
          },
          ...(isNil(IsDischarged)
            ? []
            : [{ label: "Discharged:", value: IsDischarged ? "Yes" : "No" }]),
          ...(isEmpty(dischargeDate)
            ? []
            : [
                {
                  label: dateLabel,
                  value: formatDate(dischargeDate, DateFormats.MM_DD_YYYY, null, true),
                },
              ]),
        ].map(({ label, value }) => (
          <Grid key={label} size={{ xs: 3 }} sx={FieldSpacing}>
            <ReadOnlyField label={label} value={value} />
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ marginY: 0.5, marginX: 2 }} />
      <Box sx={Title} m={"1rem 0 1rem 2rem"}>
        {TypographyBox("Service Address", colors.fonts[20], fontWeight[5])}
      </Box>
      <Grid container sx={flexRow}>
        {[
          {
            label: "Street 1:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.streetName1"
            ),
          },
          {
            label: "Street 2:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.streetName2"
            ),
          },
          {
            label: "City:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.city"
            ),
          },
          {
            label: "State:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.patientState"
            ),
          },
          {
            label: "County:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.county"
            ),
          },
          {
            label: "Zip Code:",
            value: getValue(
              tabSessionStorage,
              "response.referralSource.serviceAddressDetails.zipCode"
            ),
          },
        ].map(({ label, value }) => (
          <Grid key={label} size={{ xs: 3 }} sx={FieldSpacing}>
            <ReadOnlyField label={label} value={value} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ReferralSource;
